import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-width: 400px;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: center;
`;

export const listLinks = styled.div`
	width: 100%;
	min-width: 400px;
	height: 30vh;
	max-height: 400px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: flex-start;

	@media (max-width: 1000px) {
		min-width: 100%;
	}
`;

export const link = styled.div`
	position: relative;
	width: 99%;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> img {
		width: 80px;
		height: 80px;
		border-radius: 5px;
		object-fit: contain;
		background-color: ${color.interface.lightGray3};
	}
`;
